import React from 'react';
import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

import { formatCount } from '../../../../../../../utils/formatters';
import Texts from '../../texts.json';

import {
  StyledCount,
  Container,
  PercentageCount,
  PercentageContainer,
  StyledArrowIcon,
  StyledLabel,
  StyledHrs,
} from './styles';
import texts from './texts.json';

const StatContainer = ({
  loading,
  count,
  growth,
  isPositive,
  label,
}) => {
  const countLabel = formatCount(count);

  return (
    <Container>
      {loading ? (
        <Skeleton width={95} height={80} />
      ) : (
        <>
          <StyledCount>
            {countLabel}
            {label === Texts.fromLastWeek && (<StyledHrs>{texts.hrs}</StyledHrs>)}
          </StyledCount>
          <PercentageContainer>
            <PercentageCount $isPositive={isPositive}>
              {growth !== 0 && (
                <StyledArrowIcon $isPositive={isPositive} />
              )}
              {growth}
              %
            </PercentageCount>
            <StyledLabel>{label}</StyledLabel>
          </PercentageContainer>
        </>
      )}
    </Container>
  );
};

StatContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  count: PropTypes.number,
  growth: PropTypes.number,
  isPositive: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

StatContainer.defaultProps = {
  count: 0,
  growth: 0,
  isPositive: false,
};

export default StatContainer;
